export default __webpack_public_path__ + "static/media/FormCar.d2185e63.png";